import type { EventFormValues } from './types'
// One-way dependency: eventLength.ts imports nothing from here, so no cycle.
import { EVENT_LENGTH_DEFAULT } from './eventLength'

/** Entity type slug used in query keys and route building. */
export const EVENT_ENTITY_TYPE = 'event' as const

/** Recurrence options for the "Repeat" select. */
export const RECURRENCE_TYPES = [
  { label: 'Does Not Repeat', value: 'none' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Biweekly', value: 'biweekly' },
  { label: 'Monthly', value: 'monthly' },
] as const

/** Weekday options for the "Days Of Week" multi-select. 0=Sunday … 6=Saturday. */
export const DAYS_OF_WEEK = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
] as const

/** Blank form state — used for the add modal and as the reset baseline. */
export const EMPTY_EVENT_FORM_VALUES: EventFormValues = {
  name: '',
  category: '',
  description: '',
  starts_at: '',
  ends_at: '',
  // Every event carries a length; 1 hour is the default for a new one.
  eventLength: EVENT_LENGTH_DEFAULT,
  addressName: '',
  addressStreet1: '',
  addressStreet2: '',
  addressCity: '',
  addressPostalCode: '',
  addressCountryId: '',
  addressProvinceId: '',
  venueId: '',
  facilityId: '',
  defaultTimezone: '',
  isCustomLocation: false,
  timezone: '',
  arrivalTimeMinutes: '',
  recurrenceType: 'none',
  daysOfWeek: [],
  repeatUntil: '',
}

/**
 * Page size for the PAGINATED schedule event streams.
 *
 * Smaller than the fetch-all callers' 200, deliberately. Those size a page to
 * drain a whole schedule in one round-trip; a stream wants a page the user can
 * actually scroll past, and one large enough that the event frontier normally
 * runs ahead of the games frontier and stops constraining the merge.
 */
export const EVENTS_PER_PAGE_STREAM = 50
